// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M10.1145 21.8111C9.33859 21.1725 8.30183 20.2494 7.26196 19.112C5.2179 16.8762 3 13.637 3 10C3 5.02944 7.02944 1 12 1C16.9706 1 21 5.02944 21 10C21 13.6373 18.7821 16.8765 16.738 19.1123C15.6981 20.2496 14.6614 21.1727 13.8854 21.8112C13.2782 22.3109 12.6472 22.7686 12 23.2136C11.3529 22.7684 10.7214 22.3105 10.1145 21.8111ZM13 9.5V6.5H11V9.5H8V11.5H11V14.5H13V11.5H16V9.5H13Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-location-enlargement-filled')
export default class LocationEnlargementFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'location-enlargement-filled',
    }
  }
}
